import { useParams, Navigate } from "react-router-dom";
import { SEO } from "../components/SEO";
import { Reveal } from "../components/Reveal";
import { LEGAL_PAGES } from "../data/content";

export default function Legal() {
  const { page } = useParams();
  const doc = LEGAL_PAGES[page];
  if (!doc) return <Navigate to="/" replace />;

  return (
    <div data-testid={`legal-page-${page}`}>
      <SEO title={doc.title} description={`${doc.title} — Neeraj Battan & Associates, Chartered Accountants, Kurukshetra, Haryana.`} path={`/${page}`} />
      <section className="bg-navy text-white pt-36 pb-16 lg:pt-44 lg:pb-20 relative overflow-hidden">
        <div className="grain-overlay" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6">
          <p className="eyebrow mb-4">Legal</p>
          <h1 className="font-serif font-bold text-4xl sm:text-5xl tracking-tight" data-testid="legal-title">{doc.title}</h1>
          <p className="mt-4 text-xs font-mono uppercase tracking-[0.2em] text-slate-400">{doc.updated}</p>
        </div>
      </section>
      <section className="py-16 sm:py-20 bg-background">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 space-y-12">
          {doc.sections.map((s, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div data-testid={`legal-section-${i}`}>
                <h2 className="font-serif text-2xl font-semibold text-navy flex items-baseline gap-4">
                  <span className="font-mono text-xs text-gold">{String(i + 1).padStart(2, "0")}</span>
                  {s.heading}
                </h2>
                <div className="mt-4 space-y-4 pl-10">
                  {s.body.map((p, j) => (
                    <p key={j} className="text-sm sm:text-[15px] text-slate-600 leading-[1.85]">{p}</p>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
